// @ts-strict-ignore
import React, { useContext, useMemo, useState } from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  Separator,
} from '@usealloy/component-library';
import { IsolatedEditorContainer } from 'flow/editor/styles';
import {
  StyledTipCallout,
  StyledAggregationCriteriaContainer,
  StyledAggregationSubEditorLayout,
  StyledAggregationSubEditorRow,
  StyledAggregationSubEditorActions,
} from './styles';
import BaseAggregationsSection from './BaseAggregationsSection';
import AggregationFiltersSection from './AggregationFiltersSection';
import AggregationNameAndDescription from './AggregationNameAndDescription';
import { AggregationEditorContext } from './context';
import { getValidationErrors } from './helpers';
import type { AggregationValidationErrors } from './types';

const AggregationsSubEditorContainer = () => {
  const {
    sourceData,
    handleSave,
    handleCancel,
    aggregationEditorContainerRef,
    isSaveDisabled,
    ...restContext
  } = useContext(AggregationEditorContext);

  const [validationErrors, setValidationErrors] = useState<AggregationValidationErrors>({});

  const handleDone = () => {
    const errors = getValidationErrors(sourceData);
    setValidationErrors(errors);
    if (Object.keys(errors).length > 0) return;
    handleSave();
  };

  const innerContextValue = useMemo(() => ({
    ...restContext,
    sourceData,
    handleSave,
    handleCancel,
    aggregationEditorContainerRef,
    isSaveDisabled,
    validationErrors,
  }), [
    restContext,
    sourceData,
    handleSave,
    handleCancel,
    aggregationEditorContainerRef,
    isSaveDisabled,
    validationErrors,
  ]);

  return (
    <AggregationEditorContext.Provider value={innerContextValue}>
      <IsolatedEditorContainer ref={aggregationEditorContainerRef}>
        <StyledAggregationSubEditorLayout>
          <StyledAggregationSubEditorRow>
            <StyledAggregationCriteriaContainer>
              <StyledTipCallout text="Build your custom aggregation by selecting the options below." />
              <BaseAggregationsSection />
              <AggregationFiltersSection />
            </StyledAggregationCriteriaContainer>
            <AggregationNameAndDescription />
          </StyledAggregationSubEditorRow>
          <Separator />
          <StyledAggregationSubEditorActions>
            <Button
              size={ButtonSize.small}
              variant={ButtonVariant.secondary}
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              size={ButtonSize.small}
              variant={ButtonVariant.primary}
              disabled={isSaveDisabled}
              onClick={handleDone}
            >
              Done
            </Button>
          </StyledAggregationSubEditorActions>
        </StyledAggregationSubEditorLayout>
      </IsolatedEditorContainer>
    </AggregationEditorContext.Provider>
  );
};

export default AggregationsSubEditorContainer;
